import { useCallback, useMemo } from 'react'

import useGetObjectsByProperties from '@app/hooks/useGetObjectsByProperties'
import type { DomainChat } from '@app/types'

const useGetChattableChats = (chattableType: string, chattableId: string) => {
  const serverType = useMemo(() => chattableType.charAt(0).toUpperCase() + chattableType.slice(1), [chattableType])

  const filter = useCallback(
    (chat: DomainChat) =>
      !!chat.mostRecentPrompt &&
      chat.chattables.some(
        (chattable) => chattable.chattableId === chattableId && chattable.chattableType === serverType
      ),
    [chattableId, serverType]
  )

  return useGetObjectsByProperties('chat', filter)
}

export default useGetChattableChats
